import {
  LoadingListEntityProfile,
  PaginationList,
  ProfilePublication,
} from "Admin/Components";
import { getUnitPublications } from "Admin/Service/Unit";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
import { Empty } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Publications.module.scss";
const Publications = () => {
  const entity_id = useLocation().pathname.split("/")[3].split("-")[0];
  const entity_type = useLocation().pathname.split("/")[3].split("-")[1];
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [data, setData] = useState({ data: [], isLoading: true });
  useEffect(() => {
    setData({ ...data, isLoading: true });
    getUnitPublications(
      entity_id,
      entity_type,
      pagination.page - 1,
      pagination.rowsPerPage,
      (res) => {
        handleAPIResponse(res, () => {
          setData({
            data: res.data,
            isLoading: false,
          });
        });
      }
    );
  }, [pagination.page, pagination.rowsPerPage]);
  return (
    <div className={styles["unit-publications"]}>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data?.data?.length > 0 ? (
            data?.data?.map((item, index) => {
              return <ProfilePublication publication={item} key={index} />;
            })
          ) : (
            <Empty description="No Publication Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
      <PaginationList pagination={pagination} setPagination={setPagination} />
    </div>
  );
};

export default Publications;
